import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GlobalParameterDto, UpdateGlobalParameterDto } from "../types/api/api-types";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { axiosApi } from "./axios";

const getGlobalParameters = async () => {
  const response = await axiosApi.get<GlobalParameterDto>(`/global-parameters`);
  return response.data;
};

export const useGetGlobalParameters = () => {
  return useQuery({
    queryKey: ["getGlobalParameters"],
    queryFn: () => getGlobalParameters(),
  });
};

const updateGlobalParameters = async (data: UpdateGlobalParameterDto) => {
  return axiosApi.patch(`/global-parameters`, data);
};

export const useUpdateGlobalParameters = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boParameters");

  return useMutation({
    mutationFn: updateGlobalParameters,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getGlobalParameters"],
      });
    },
    onError: () => {
      toast.error(t("globalParametersApi.updateError"));
    },
  });
};
